export default __webpack_public_path__ + "static/media/galleryImg3.59903290.png";